import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import CourseTable from "./CouseTable";
import CourseHeader from "./CourseHeader";

const CourseList = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <CourseHeader />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <CourseTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default CourseList;
